define('modules/editor/behaviours/has_resizebox',['require','exports','module','../models/editorstate','backbone','../views/controls/resizebox'],function(require, exports, module){
  "use strict";
  var EditorState = require("../models/editorstate"),
      GroupState = EditorState.groupState,
      Backbone = require("backbone"),
      ResizeBox = require("../views/controls/resizebox");

  /**
   * HasResizeBox (Page View Behaviour)
   *
   * Displays the resize box when an item is selected
   */
  var HasResizeBox = {
    mixed: function(klass, proto){
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init){
        init.apply(this, _.rest(arguments));
        this.resizeBox = null;
        this.selectedView = null;
        this.resizeState = new Backbone.Model();
        this.listenTo(EditorState, EditorState.SELECTED_ELEMENT_CHANGE, _.debounce(this._displayResizeBox, 250));
      });
      proto.onRender = _.wrap(proto.onRender || _.identity, this._onResizeRender);
      proto.onRemove = _.wrap(proto.onRemove || _.identity, function(fn){
        this._removeResizeBox();
        fn.apply(this, _.rest(arguments));
      });
    },
    _onResizeRender: function(onRender){
      //remove the box before re-rendering
      this._removeResizeBox();
      //create it again
      this._createResizeBox();
      onRender.apply(this, _.rest(arguments));
    },
    _displayResizeBox: function(model, elementView){
      if(!elementView || GroupState.getGroupCount() > 1){
        this._hideResizeBox();
        this._clearResizeState();
        return;
      }
      elementView = GroupState.getFirstView() || elementView;
      this._updateResizeState(elementView);
      this._createResizeBox();
      this._positionResizeBox(elementView);
    },
    _updateResizeState: function(elementView){
      var oldView = this.resizeState.get("view");
      if(oldView){
        this.stopListening(oldView, "element:property:render");
      }
      if(!elementView || !elementView.model) {
        return;
      }

      this.resizeState.set("view", elementView);
      this.resizeState.set("model", elementView.model);
      this.resizeState.set("originalSize", elementView.model.getSize());
      this.resizeState.set("originalPos", elementView.model.getPosition());
      //reposition the resizebox when the element is changed
      //this causes the resize box to follow the mouse when dragging handles around
      this.listenTo(elementView, "element:property:render", function(){
        this._displayResizeBox(null, elementView);
      });
    },
    //clean up state model
    _clearResizeState: function(){
      var view = this.resizeState.get("view");
      if(view){
        this.stopListening(view);
      }
      this.resizeState.clear({ silent: true });
    },
    _createResizeBox: function(){
      if(this.resizeBox) { return; }
      //inter-bar vent
      this.resizeBox = {
        topBar: new ResizeBox.TopBar({ resizeState: this.resizeState }),
        bottomBar: new ResizeBox.BottomBar({ resizeState: this.resizeState }),
        leftBar: new ResizeBox.LeftBar({ resizeState: this.resizeState }),
        rightBar: new ResizeBox.RightBar({ resizeState: this.resizeState })
      };

      _.each(this.resizeBox, function(barView){
        this.$el.prepend(barView.render().$el);
      }, this);
    },
    _removeResizeBox: function(){
      //clean up
      if(this.resizeBox){
        _.each(this.resizeBox, function(resizeBar){
          resizeBar.remove();
        });
        delete this.resizeBox;
      }
      this.selectedView = null;
      this._clearResizeState();
    },
    _hideResizeBox: function(){
      if(!this.resizeBox) { return; }

      _.each(this.resizeBox, function(resizeBar){
        resizeBar.$el.hide();
      });
    },
    _positionResizeBox: function(elementView){
      var config = this._getBoxConfiguration(elementView.model.name);
      _.each(this.resizeBox, function(barView){
        barView.configure(elementView, config);
        barView.$el.show();
      }, this);
    },
    _getBoxConfiguration: function(modelName){
      var defaults = { height: true, width: true };
      if(modelName === "section"){
        defaults.width = false;
      }
      if(modelName === "element:form"){
        defaults.height = false;
      }
      return defaults;
    }

  };

  module.exports = HasResizeBox;
});

